import { BlurbDownloadCard } from 'ui/components';

export const BlurbDownloadCardFeature: React.FC<Umbraco.BlurbDownloadCard> = ({ content }) => <BlurbDownloadCard {...content?.properties} />;
